module.exports = __webpack_public_path__ + "static/media/i_mover.48d6ee08.svg";